import store from '@/store/index.js'
const restriction = [
    {
        userName: 'SpammerChernivci',
        restrictedBots: ['RoyalClub Lviv'],
        restrictedMenus: ['settings'],
    },
]

const designUsers = [
    'Sasha'
]

function isRestrictedRole() {
    const userName = store.getters.StateUser //'SpammerChernivci' //store.state.user;
    const userRestriction = restriction.find(item => item.userName === userName);
    if (userRestriction) {
        return {
            restrictedBots: userRestriction.restrictedBots,
            restrictedMenus: userRestriction.restrictedMenus,
        };
    }
    return null;
}

function isKioskDesignerRole() {
    const userName = store.getters.StateUser;
    return  designUsers.includes(userName);
}

export { isRestrictedRole, isKioskDesignerRole };
